import React from "react";
import { Compass, PenTool, Hammer, Truck } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Écoute & besoin",
    desc: "Premier échange pour comprendre vos envies, contraintes et budget.",
    icon: Compass,
  },
  {
    n: "02",
    title: "Conception",
    desc: "Plans, croquis 3D et choix des matériaux adaptés à votre style.",
    icon: PenTool,
  },
  {
    n: "03",
    title: "Fabrication",
    desc: "Pilotage de la fabrication chez des artisans sélectionnés.",
    icon: Hammer,
  },
  {
    n: "04",
    title: "Pose & livraison",
    desc: "Coordination de la pose à La Réunion, finitions au cordeau.",
    icon: Truck,
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 max-w-2xl">
          <p className="mb-4 text-xs uppercase tracking-[0.25em] text-orange-800">
            Processus
          </p>
          <h2 className="text-3xl font-light leading-tight tracking-tight text-stone-900 sm:text-5xl">
            De l'idée à l'installation,
            <br />
            <span className="italic">je m'occupe de tout.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-stone-200 bg-stone-200 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`process-step-${i + 1}`}
                className="group relative flex flex-col gap-6 bg-white p-8 transition-colors hover:bg-stone-50 sm:p-10"
              >
                <div className="flex items-center justify-between">
                  <span className="text-xs uppercase tracking-[0.25em] text-stone-400">
                    Étape {s.n}
                  </span>
                  <Icon className="h-5 w-5 text-orange-800" strokeWidth={1.5} />
                </div>
                <div className="text-5xl font-light tracking-tight text-stone-200 transition-colors group-hover:text-orange-200 tick">
                  {s.n}
                </div>
                <div>
                  <h3 className="text-xl font-medium text-stone-900">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-stone-600">
                    {s.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
